import { AdaptiveOverpayment } from './types.js';
import { roundCents } from './rounding.js';

export interface AdaptivePaymentContext {
  scheduledPayment: number;   // cents charged as the scheduled payment this month
  balance: number;            // cents still owed after the scheduled payment
}

/**
 * Overpayment that tops the scheduled payment up to the adaptive target:
 * `min(max(target - scheduledPayment, minAmount), balance)`, never negative.
 * The minimum is enforced before the balance cap, so the last overpayment can
 * be smaller than the minimum only because nothing more is owed.
 */
export function calculateAdaptiveOverpayment(
  adaptive: AdaptiveOverpayment,
  ctx: AdaptivePaymentContext,
): number {
  const topUp = roundCents(adaptive.targetAmount) - ctx.scheduledPayment;
  const wanted = Math.max(topUp, roundCents(adaptive.minAmount));
  return Math.max(0, Math.min(wanted, ctx.balance));
}
